"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Created by nina.kirakosyan on 11/18/2020.
 */
var overlay_1 = require("@angular/cdk/overlay");
/**
 * Tooltip Position class, with predefined tooltip positioning strategy options.
 */
var SisTooltipPosition = /** @class */ (function () {
    function SisTooltipPosition() {
    }
    /**
     * Returns the positions array for given target placement - positions
     * starting from the indicated placement, with fallback positions.
     * @returns {ConnectionPositionPair[]}
     */
    SisTooltipPosition.getPositionArray = function (target) {
        var targetArray = SisTooltipPosition.POSITIONS.find(function (posArray) { return posArray.indexOf(target) > -1; });
        var targetIndex = targetArray.indexOf(target);
        var reorderedArray = SisTooltipPosition.reorderArrayCircularly(target, targetArray);
        var fallbackArrays = SisTooltipPosition.reorderArrayCircularly(targetArray, SisTooltipPosition.POSITIONS);
        fallbackArrays = fallbackArrays.map(function (item) {
            return item == targetArray ? reorderedArray : SisTooltipPosition.reorderArrayCircularly(item[targetIndex], item);
        });
        return [].concat.apply([], fallbackArrays);
    };
    SisTooltipPosition.reorderArrayCircularly = function (target, array) {
        var i = array.indexOf(target);
        return i > -1 ? array.slice(i).concat(array.slice(0, i)) : [];
    };
    /**
     * Returns ConnectionPositionPair corresponding to passed Origin X/Y & Overlay X/Y types.
     * @param originX horizontal origin position index
     * @param originY vertical origin position index
     * @param overlayX horizontal overlay position index
     * @param overlayY vertical overlay position index
     * @returns {ConnectionPositionPair}
     */
    SisTooltipPosition.getConPosPair = function (originX, originY, overlayX, overlayY) {
        return new overlay_1.ConnectionPositionPair(SisTooltipPosition.getOriginPosition(originX, originY), SisTooltipPosition.getOverlayPosition(overlayX, overlayY));
    };
    /**
     * Returns OriginConnectionPosition corresponding to passed X and Y types.
     * @param i horizontal position index
     * @param j vertical position index
     * @returns {OriginConnectionPosition}
     */
    SisTooltipPosition.getOriginPosition = function (i, j) {
        return {
            originX: SisTooltipPosition.xPos[i],
            originY: SisTooltipPosition.yPos[j],
        };
    };
    /**
     * Returns OverlayConnectionPosition corresponding to passed X and Y types.
     * @param i horizontal position index
     * @param j vertical position index
     * @returns {OverlayConnectionPosition}
     */
    SisTooltipPosition.getOverlayPosition = function (i, j) {
        return {
            overlayX: SisTooltipPosition.xPos[i],
            overlayY: SisTooltipPosition.yPos[j],
        };
    };
    /**
     * Array of available horizontal position types.
     * @type {HorizontalConnectionPos[]}
     */
    SisTooltipPosition.xPos = ['start', 'center', 'end'];
    /**
     * Array of available vertical position types.
     * @type {VerticalConnectionPos[]}
     */
    SisTooltipPosition.yPos = ['top', 'center', 'bottom'];
    // ConnectionPosition pairs for available tooltip placements
    SisTooltipPosition.UP = SisTooltipPosition.getConPosPair(1, 0, 1, 2);
    SisTooltipPosition.UP_LEFT = SisTooltipPosition.getConPosPair(0, 0, 0, 2);
    SisTooltipPosition.UP_RIGHT = SisTooltipPosition.getConPosPair(2, 0, 2, 2);
    SisTooltipPosition.RIGHT = SisTooltipPosition.getConPosPair(2, 1, 0, 1);
    SisTooltipPosition.RIGHT_UP = SisTooltipPosition.getConPosPair(2, 2, 0, 2);
    SisTooltipPosition.RIGHT_DOWN = SisTooltipPosition.getConPosPair(2, 0, 0, 0);
    SisTooltipPosition.DOWN = SisTooltipPosition.getConPosPair(1, 2, 1, 0);
    SisTooltipPosition.DOWN_LEFT = SisTooltipPosition.getConPosPair(0, 2, 0, 0);
    SisTooltipPosition.DOWN_RIGHT = SisTooltipPosition.getConPosPair(2, 2, 2, 0);
    SisTooltipPosition.LEFT = SisTooltipPosition.getConPosPair(0, 1, 2, 1);
    SisTooltipPosition.LEFT_UP = SisTooltipPosition.getConPosPair(0, 2, 2, 2);
    SisTooltipPosition.LEFT_DOWN = SisTooltipPosition.getConPosPair(0, 0, 2, 0);
    SisTooltipPosition.POS_UP = [
        SisTooltipPosition.UP,
        SisTooltipPosition.UP_LEFT,
        SisTooltipPosition.UP,
        SisTooltipPosition.UP_RIGHT,
        SisTooltipPosition.UP,
        SisTooltipPosition.UP_LEFT
    ];
    SisTooltipPosition.POS_DOWN = [
        SisTooltipPosition.DOWN,
        SisTooltipPosition.DOWN_LEFT,
        SisTooltipPosition.DOWN,
        SisTooltipPosition.DOWN_RIGHT,
        SisTooltipPosition.DOWN,
        SisTooltipPosition.DOWN_LEFT
    ];
    SisTooltipPosition.POS_LEFT = [
        SisTooltipPosition.LEFT,
        SisTooltipPosition.LEFT_UP,
        SisTooltipPosition.LEFT,
        SisTooltipPosition.LEFT_DOWN,
        SisTooltipPosition.LEFT,
        SisTooltipPosition.LEFT_UP
    ];
    SisTooltipPosition.POS_RIGHT = [
        SisTooltipPosition.RIGHT,
        SisTooltipPosition.RIGHT_UP,
        SisTooltipPosition.RIGHT,
        SisTooltipPosition.RIGHT_DOWN,
        SisTooltipPosition.RIGHT,
        SisTooltipPosition.RIGHT_UP
    ];
    SisTooltipPosition.POSITIONS = [
        SisTooltipPosition.POS_UP,
        SisTooltipPosition.POS_DOWN,
        SisTooltipPosition.POS_UP,
        SisTooltipPosition.POS_LEFT,
        SisTooltipPosition.POS_RIGHT,
        SisTooltipPosition.POS_LEFT
    ];
    return SisTooltipPosition;
}());
exports.SisTooltipPosition = SisTooltipPosition;
//# sourceMappingURL=tooltip-configs.model.js.map